<template>
  <div
    :class="{
      'bg-v-300': selected,
      'bg-n-700': !selected
    }"
    class="category p-2 flex items-center justify-center text-n-0 text-center rounded font-body text-sm cursor-pointer"
    @click="$emit('selected')"
  >
    {{ category.name }}
  </div>
</template>

<script setup lang="ts">
defineProps<{
  category: {
    id: string
    name: string
  }
  selected: boolean
}>()

defineEmits<{
  selected: []
}>()
</script>

<style>
.category {
  transition: 0.3s ease;
  width: 100%;
  height: 3.5rem;
  overflow: hidden;
}

@media screen and (max-width: 640px) {
  .category {
    height: 3rem;
  }
}
</style>
